export class TipologiaFascicoloCorrelataVO {
  codice: string;
  nome: string;
  id: string;
}
